import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { useConfirmStore } from '@/stores/useConfirmStore';

export function GlobalConfirm() {
  const isOpen = useConfirmStore((state) => state.isOpen);
  const options = useConfirmStore((state) => state.options);
  const { closeConfirm, confirmAction } = useConfirmStore((state) => state.actions);

  return (
    <Dialog fullWidth maxWidth="sm" onClose={closeConfirm} open={isOpen}>
      <DialogTitle>{options?.title}</DialogTitle>
      {options?.message ? (
        <DialogContent>
          <DialogContentText>{options.message}</DialogContentText>
        </DialogContent>
      ) : null}
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={closeConfirm}>{options?.cancelText}</Button>
        <Button autoFocus color="error" onClick={confirmAction} variant="contained">
          {options?.confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
